/*
 * (c) Copyright, 2024, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import ActionsMenu from '../../../../components/shared/ActionsMenu'
import { useFsiActionMenu } from '../../../../hooks/useFsiActionMenu'

interface TableMenuProps {
  item: any
  options?: any
}

const TableMenu: React.FC<TableMenuProps> = ({ item, options = {} }) => {
  const { items, setIsOpen } = useFsiActionMenu(item, options)

  // Add fallback if no items
  if (items.length === 0) {
    items.push({ value: 'ACTION_MENU_NO_ACTION_AVAILABLE', disabled: true })
  }

  return (
    <ActionsMenu
      menuId={`action-menu-overview-${item.id}`}
      onToggle={(open: boolean) => {
        setIsOpen(open)
      }}
      items={items}
    />
  )
}

export default TableMenu
